import React, { useEffect, useRef, useState } from "react";
import { isLogin } from "@/src/models/loginModel";
import { useProductDetailsContext } from "@/src/provider";
import { FmIcon, FmToast } from "@/ui-component";
import { account, signInModal } from "@/store";
import variable from "@/src/styles/variables.module.scss";
import stl from "./buttonline.module.scss";
import classnames from "classnames";
interface Props {
    productsid?: number;
}

const FavoriteBtn: React.FC<Props> = (props) => {
    const [activeObj] = useProductDetailsContext((state) => [state.activeObj]);
    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);
    const [is_favorite, setIsFavorite] = useState(activeObj.is_favorite);

    const [toastChildren, setToastChildren] = useState("");
    const [addFavorite] = account.useAccountStore((state) => [
        state.addFavorite,
    ]);
    const loadingRef = useRef(false);
    //收藏商品
    const handleAddFavorite = () => {
        if (activeObj.colorUnderMarket) {
            return;
        }
        // color_id: id,
        // const {}
        const is_login = isLogin();
        if (!is_login) {
            openModal(() => {
                addFavorite({
                    productId: props.productsid!,
                    colorsId: activeObj.id!,
                    activeColor: {
                        price: activeObj.onsale?.price! as number,
                    },
                });
            });
        } else {
            setIsFavorite(!is_favorite);
            addFavorite({
                productId: props.productsid!,
                colorsId: activeObj.id!,
                activeColor: {
                    price: activeObj.onsale?.price! as number,
                },
            });
        }
    };

    // //收藏商品请求
    // const addFa = () => {
    //     if (props.productsid && activeObj.id) {
    //         acquisition.addWishlist(
    //             "addWishlist",
    //             `${props.productsid}-${activeObj.id}`,
    //         );
    //     }
    //     if (loadingRef.current) return;
    //     loadingRef.current = true;
    //     postAccount(FAVORITE, {
    //         products_id: productDetail.products_id,
    //         colors_id: activeObj.id,
    //     })
    //         .then(() => {
    //             addFavouriteClickEvent({
    //                 colorId: activeObj.id,
    //                 price: activeObj.onsale?.price,
    //             });
    //             new Reddit(host).AddToWishlist({
    //                 currency: getCookieItem(CURRENCY_COOKIE_NAME),
    //                 itemCount: 1,
    //                 value: activeObj.onsale?.price,
    //             });
    //             activeObj.is_favorite ? delFavoriteNum() : addFavoriteNum();
    //             changeFavorite(activeObj.id!);
    //             loadingRef.current = false;
    //         })
    //         .catch((e) => {
    //             loadingRef.current = false;
    //             setToastChildren(e);
    //         });
    // };

    return (
        <>
            <FmToast
                visible={!!toastChildren.length}
                type={"info"}
                onChange={() => setToastChildren("")}
            >
                {toastChildren}
            </FmToast>
            <FmIcon
                className={classnames(
                    stl["empty-heart-icon"],
                    stl["button-line-icon"],
                )}
                onClick={handleAddFavorite}
                icon={`${is_favorite ? "icon--full-heart" : "icon--empty-heart"}`}
                style={{
                    color: `${
                        !activeObj.colorUnderMarket && is_favorite
                            ? variable.main
                            : variable.text_3
                    }`,
                }}
            />
        </>
    );
};

export default FavoriteBtn;
